export { default } from './HowToSkeleton';
